export const ODATA_ENDPOINT = 'odata'; // will be appended to the endpoint provided by user
export const AUTH_ENDPOINT = 'wztc.auth.endpoint'; // storage key for sharing endpoint between widnows
